import { AGSResultBuilder } from "ags/integration/builders/results/abstract-ags-result-builder";
import { HoldAndSpinScatterResult } from "ags/integration/model/results/hold-and-spin-scatter-result";
import { HoldAndSpinSchema } from "ags/integration/schema/ags-spin-response-schema";
import { getReelIndexFromCoordinate } from "ags/utils/flat-matrix-conversion";
import betModel from "slotworks/model/bets/bet-model";
import Record from "slotworks/model/gameplay/records/record";

export class CMScatterSymbolResultBuilder extends AGSResultBuilder {
    public static scatterSymbolId = 13;

    public filter(data: any): boolean {
        return data.MCSymbols !== undefined;
    }

    public build(record: Record, data: HoldAndSpinSchema): HoldAndSpinScatterResult[] {
        const results = [];
        for (const symbol of data.MCSymbols) {
            if (symbol.symbol !== CMScatterSymbolResultBuilder.scatterSymbolId) {
                continue;
            }
            const result = new HoldAndSpinScatterResult("hold and spin");
            result.reel = getReelIndexFromCoordinate(symbol);
            result.winAmount = symbol.winAmount / betModel.getCreditSize();

            if (symbol.JPSymbolIfString) {
                result.jackpotTier = symbol.JPSymbolIfString.toUpperCase();
            }

            results.push(result);
        }
        return results;
    }
}

export default new CMScatterSymbolResultBuilder();
